<template>
  <div>
    <b-modal
      id="modal-material"
      :title="
        editMaterials.id
          ? $t('reference.edit_material')
          : $t('reference.add_material')
      "
      cancel-variant="outline-secondary"
      :ok-title="editMaterials.id ? $t('edit') : $t('save')"
      :ok-variant="editMaterials.id ? 'warning' : 'success'"
      :cancel-title="$t('cancel')"
      centered
      no-close-on-backdrop
      @show="showModal"
      @ok="onSubmitMaterial"
    >
      <validation-observer ref="materialValidations">
        <b-form>
          <b-form-group :label="$t('reference.name')">
            <validation-provider
              #default="{ errors }"
              :name="$t('reference.name') + ' uz'"
              rules="required"
            >
              <b-form-input v-model="material.value" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group :label="$t('reference.unit')">
            <validation-provider
              #default="{ errors }"
              :name="$t('reference.unit')"
              rules="required"
            >
              <v-select
                v-model="material.unity"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="short_title"
                :reduce="(p) => p.id"
                :options="GET_UNITS.results"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group :label="$t('package')">
            <b-form-checkbox v-model="material.package"> </b-form-checkbox>
          </b-form-group>

          <b-form-group
            :label="$t('reference.packaging')"
            v-if="material.package"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('reference.packaging')"
              rules="required"
            >
              <v-select
                v-model="material.min_unity"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="GET_UNITS.results"
                :reduce="(p) => p.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            :label="$t('reference.multipliers')"
            v-if="material.package"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('reference.multipliers')"
              rules="required"
            >
              <b-form-input v-model="material.min_qty" type="number" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BTabs,
  BTab,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BTabs,
    BTab,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    editMaterials: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    category: {
      type: [Number, String],
      required: false,
    },
  },
  data() {
    return {



      // ===============  PRIMARY_DATA_SECTION START ===============
      editCharacter: {},
      required,
      material: {
        value: "",
        package: false,
        product: "",
        unity: null,
        min_unity: null,
        min_qty: "",
      },
      option: [],
      page: 1,
      // ===============  PRIMARY_DATA_SECTION END ===============




    }
  },
  watch: {



    // ===============  PRIMARY_WATCHERS_SECTION START ===============
    category(newValue, oldValue){
      this.material.product = newValue
    }
    // ===============  PRIMARY_WATCHERS_SECTION END ===============



  },
  computed: {
    ...mapGetters("characterUnits", ["", "GET_UNITS"]),
    ...mapState("materials", ["product_categories"]),
  },
  async mounted() {



    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_UNITS({page_size: 1000})
    // ===============  PRIMARY_REQUESTS_SECTION END ===============



  },
  methods: {
    ...mapActions("materials", [
      "CREATE_MATERIALS_TABLE_ID",
      "FETCH_MATERIALS_TABLE_ID",
      "UPDATE_MATERIALS_TABLE_ID",
    ]),
    ...mapActions("characterUnits", ["FETCH_UNITS"]),




    // ===============  SHOW_MODAL_SECTION START ===============
    showModal() {
      this.material = {
        value: "",
        product: this.category,
        unity: null,
        min_unity: null,
        min_qty: null,
      };
      if (!this.editMaterials || !this.editMaterials.value) {
        return;
      }
      const { unity, min_unity, min_qty, product, value } = this.editMaterials;
      let min_unity_id = this.GET_UNITS.results.find((elem) => {
        if (min_unity) {
          return elem.title == min_unity;
        }
      });
      let unity_id = this.GET_UNITS.results.find((elem) => {
        if (unity) {
          return elem.short_title == unity;
        }
      });

      this.material = {
        value: value,
        product: product.id,
        unity: unity_id && unity_id.id ? unity_id.id : null,
        min_unity: min_unity_id && min_unity_id.id ? min_unity_id.id : null,
        min_qty,
      };
    },
    // ===============  SHOW_MODAL_SECTION END ===============

    onSubmitMaterial(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.$refs.materialValidations.validate().then(async (success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }
        try {
          if (this.editMaterials.id) {
            await this.UPDATE_MATERIALS_TABLE_ID({
              id: this.editMaterials.id,
              data: this.material,
            });
          } else {
            await this.CREATE_MATERIALS_TABLE_ID(this.material);
          }

          this.$nextTick(() => {
            this.$bvModal.hide("modal-material");
          });
          this.material = {
            value: "",
            product: this.category,
            unity: null,
            min_unity: null,
            min_qty: "",
          };

          this.$parent.refresh2()

          this.$_okToast();
        } catch (err) {
          this.$_errToast('Error');
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
